import { get, post, patch } from './client.js';

const base = (orgId) => `/orgs/${orgId}/support`;

export const orgSupportApi = {
  listTickets: (orgId, status) => get(status ? `${base(orgId)}/tickets?status=${status}` : `${base(orgId)}/tickets`),
  stats: (orgId) => get(`${base(orgId)}/tickets/stats`),
  getTicket: (orgId, ticketId) => get(`${base(orgId)}/tickets/${ticketId}`),
  createTicket: (orgId, data) => post(`${base(orgId)}/tickets`, data),
  updateStatus: (orgId, ticketId, status) => patch(`${base(orgId)}/tickets/${ticketId}/status`, { status }),
  addComment: (orgId, ticketId, body, internal = false) => post(`${base(orgId)}/tickets/${ticketId}/comments`, { body, internal }),
  addMessage: (orgId, ticketId, message) => post(`${base(orgId)}/tickets/${ticketId}/messages`, { body: message }),
};
